<template>
  <div :class="`project-${protocol.id}-tab accordion`" role="tablist">
    <AccessBlock v-for="section in sections" :key="section.blockId" :id="section.blockId">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle="collapseIdOf(section)"
          variant="outline-primary"
          class="text-left accordion-header"
        >
          {{ $t(section.labelKey) }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse :id="collapseIdOf(section)" role="tabpanel" visible>
          <div class="accordion-content px-2 py-2">
            <component
              :is="section.component"
              v-if="blockOf(section)"
              :blockId="section.blockId"
              :project="blockOf(section)"
              :protocol="protocol"
            />
          </div>
        </b-collapse>
      </div>
    </AccessBlock>
  </div>
</template>

<script>
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectReportApproval from '@/blocks/project/report/ProjectReportApproval';
import ProjectReportBuild from '@/blocks/project/report/ProjectReportBuild';
import ProjectReportVerification from '@/blocks/project/report/ProjectReportVerification';

/** Number of the unsaved project (ProjectEdit `_new`); it has no blocks yet. */
const NEW_PROJECT_NUMBER = '_new';

/** Block component of each section entry of a protocol config, in the order of the tab. */
const SECTION_COMPONENTS = [
  ['build', () => ProjectReportBuild],
  ['verification', () => ProjectReportVerification],
  ['approval', () => ProjectReportApproval],
  ['data', (protocol) => protocol.data.dataComponent],
];

/**
 * Protocol tab of the project detail (see feature page projekt-protokolle): one accordion section
 * per entry of `protocol` (`reportProtocols.js`) that the protocol has, one block each, all open
 * at the start. Each section sits inside its `AccessBlock`, so it disappears without a level and
 * its header stays usable for readers.
 */
export default {
  name: 'ProjectReportTab',
  components: { AccessBlock },
  props: {
    project: { type: Object, required: true },
    protocol: { type: Object, required: true },
  },
  computed: {
    sections() {
      return SECTION_COMPONENTS.filter(([key]) => this.protocol[key]).map(([key, componentOf]) => ({
        ...this.protocol[key],
        component: componentOf(this.protocol),
      }));
    },
  },
  methods: {
    collapseIdOf(section) {
      return `project-${this.protocol.id}-${section.blockField}`;
    },
    /** Block data; the unsaved project goes to the block itself. Null while not loaded. */
    blockOf(section) {
      if (this.project.number === NEW_PROJECT_NUMBER) {
        return this.project;
      }

      return this.project.blocks?.[section.blockField] ?? null;
    },
  },
};
</script>
